import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
export default class PollTitle extends Component {
  view() {
    return m("div", {
      className: "Poll-title-component"
    }, this.pollTitleItems().toArray());
  }
  pollTitleItems() {
    const items = new ItemList();
    items.add('title', m("h3", {
      className: "Poll-title"
    }, this.attrs.poll.question()));
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollTitle', PollTitle);